const partesData = data => Object.fromEntries(new Intl.DateTimeFormat('pt-BR', {
  timeZone: 'America/Sao_Paulo', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
}).formatToParts(data).map(p => [p.type, p.value]));
const diaCivil = p => Date.UTC(Number(p.year), Number(p.month) - 1, Number(p.day));
export function horarioHistorico(valor, agora = new Date()) {
  if (!valor) return '';
  const data = new Date(valor);
  if (!Number.isFinite(data.getTime())) return '';
  const p = partesData(data);
  const dias = Math.round((diaCivil(partesData(agora)) - diaCivil(p)) / 86400000);
  const dia = ({ 0: 'Hoje', 1: 'Ontem', 2: 'Anteontem' })[dias] || `${p.day}/${p.month}/${p.year}`;
  return `${dia}, ${p.hour}:${p.minute}`;
}
export function montarHistorico(simulacao, agora = new Date()) {
  if (!simulacao) return [];
  const eventos = (simulacao.historico || []).map(e => ({ ...e, sistema: true }));
  if (!eventos.some(e => e.acao === 'criacao') && simulacao.createdAt) eventos.push({
    _id: `criacao-${simulacao._id}`, sistema: true, criadoEm: simulacao.createdAt,
    usuario_nome: simulacao.usuario_id?.nome || 'Usuário criador', texto: 'incluiu a simulação.', acao: 'criacao'
  });
  const lista = [...eventos, ...(Array.isArray(simulacao.observacoes) ? simulacao.observacoes.map(e => ({ ...e, sistema: false })) : [])]
    .sort((a, b) => (new Date(a.criadoEm).getTime() || 0) - (new Date(b.criadoEm).getTime() || 0));
  let inicio = null, dia = null;
  lista.forEach((item, i) => {
    const tempo = item.criadoEm ? new Date(item.criadoEm).getTime() : NaN;
    const diaItem = Number.isFinite(tempo) ? diaCivil(partesData(new Date(tempo))) : null;
    if (inicio === null || !Number.isFinite(tempo) || tempo - inicio >= 5 * 60000 || dia !== diaItem) {
      if (i > 0) lista[i - 1].marcacao = horarioHistorico(lista[i - 1].criadoEm, agora);
      inicio = Number.isFinite(tempo) ? tempo : null; dia = diaItem;
    }
  });
  if (lista.length) lista[lista.length - 1].marcacao = horarioHistorico(lista[lista.length - 1].criadoEm, agora);
  return lista;
}
